var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlastLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.536,
    height: 38.536,
    viewBox: "0 0 38.536 38.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_336",
    "data-name": "\\uADF8\\uB8F9 336",
    transform: "translate(-409.732 -191.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_334",
    "data-name": "\\uADF8\\uB8F9 334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3853",
    "data-name": "\\uD328\\uC2A4 3853",
    d: "M425.639,219.376l-9.35-13.765a1.792,1.792,0,0,0-2.463-.5q-.07.046-.136.1l-.245.195a1.792,1.792,0,0,1-2.1.094,1.794,1.794,0,0,0-2.467.49q-.031.046-.059.094l-.467.782a1.781,1.781,0,0,1-1.543.879v26.039a1.787,1.787,0,0,0,1.058-.345l17.343-11.575a1.818,1.818,0,0,0,.428-2.487",
    transform: "translate(22.19 -3.515)",
    fill: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3854",
    "data-name": "\\uD328\\uC2A4 3854",
    d: "M2.928,219.375l9.35-13.765a1.793,1.793,0,0,1,2.464-.5q.07.046.136.1l.245.195a1.792,1.792,0,0,0,2.1.093,1.794,1.794,0,0,1,2.468.49q.031.046.059.094l.467.782a1.782,1.782,0,0,0,1.543.879v26.039a1.787,1.787,0,0,1-1.058-.345L3.356,221.861a1.818,1.818,0,0,1-.428-2.487",
    transform: "translate(407.242 -3.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3855",
    "data-name": "\\uD328\\uC2A4 3855",
    d: "M18.16.355.777,10.382a1.846,1.846,0,0,0-.645,2.189L2.576,19.81,10.61,7.421a3.106,3.106,0,0,1,2.608-1.409,29.961,29.961,0,0,0,6.049.622V0A1.9,1.9,0,0,0,18.16.355",
    transform: "translate(409.732 191.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3856",
    "data-name": "\\uD328\\uC2A4 3856",
    d: "M425.291,10.382,407.908.355A1.9,1.9,0,0,0,406.8,0V6.635a29.964,29.964,0,0,0,6.05-.622,3.106,3.106,0,0,1,2.608,1.409l8.034,12.388,2.444-7.239a1.847,1.847,0,0,0-.645-2.189",
    transform: "translate(22.2 191.732)",
    fill: "#a3a3a3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlastLogoWhite);
export default __webpack_public_path__ + "static/media/blast-logo-white.a8f0df34.svg";
export { ForwardRef as ReactComponent };